import { NavLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import queryString from 'query-string';

const Pagination = ({ listPages }) => {
    return (
        <div className="filmik__pagination pagination">
            <ul className="pagination__pages">
                {listPages}
            </ul>
        </div>
    );
};

Pagination.propTypes = {
    listPages: PropTypes.oneOfType([PropTypes.array.isRequired, PropTypes.oneOf([null]).isRequired]),
};

const PaginationContainer = ({countMovies}) => {
    const location = useLocation();
    const query = queryString.parse(location.search,{arrayFormat: 'comma'});

    const countPages = Math.ceil(countMovies / 8);
    const pages = new Array(countPages).fill(null);

    delete query.page;

    let listPages = pages.map((_, id) => {
        return (
            <li key={id} className="pagination__page" onClick={() => window.scrollTo(0, 0)}>
                <NavLink className='pagination__btn' activeClassName='pagination__btn--active' to={`${location.pathname}?${queryString.stringify(query, {arrayFormat: 'comma'})}${(Object.keys(query).length) ? '&' : ''}page=${id + 1}`} isActive={(__, location) => location.search.includes(`page=${id + 1}&`) || location.search.endsWith(`page=${id + 1}`)}>{id + 1}</NavLink>
            </li>
        );
    });

    listPages = (pages.length > 1) ? listPages : null;

    return <Pagination listPages={listPages} />;
};

export default PaginationContainer;